export default __webpack_public_path__ + "static/media/popup.4868a0d6.jpg";